import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: EasyEvent.theme.primary_color,
        secondary: EasyEvent.theme.secondary_color,
        accent: EasyEvent.theme.accent_color,
      }
    }
  }
}

export default new Vuetify(opts)
